<template>
  <CommonOverlay
    class="overlay"
  >
    <CommonModal class="modal">
      <div class="user-register">
        <div class="row_area">
          <div class="input-area">
            <div class="address_area">
              <v-select
                v-if="countryList"
                label="Country"
                outlined
                :items="countryList"
                item-text="name"
                item-value="id"
                v-model="countryId"
                hide-details="auto"
                prepend-inner-icon="mdi-earth"
              ></v-select>
              <ErrorMessage
                v-if="errorMessageCountryId"
                class="error-message"
                :message="errorMessageCountryId"
              />
            </div>

            <div class="address_area">
              <v-select
                v-if="languageList"
                label="Language"
                outlined
                :items="languageList"
                item-text="name"
                item-value="id"
                v-model="languageId"
                hide-details="auto"
                prepend-inner-icon="mdi-earth"
              ></v-select>
              <ErrorMessage
                v-if="errorMessageLanguageId"
                class="error-message"
                :message="errorMessageLanguageId"
              />
            </div>

            <div class="button-area">
              <BuyButton
                class="square-button purchase-btn"
                :text="t('登録')"
                :isArrow="false"
                @handleSquareBtnClick="register"
              />
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  </CommonOverlay>
</template>

<script>
import { mapGetters } from 'vuex';
import t from '@/plugins/i18n';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';

export default {
  name: 'CountryPopup',
  mixins: [t],

  components: {
    CommonOverlay,
    CommonModal,
    BuyButton,
    ErrorMessage,
  },

  data: () => ({
    countryId: '84',
    languageId: '1',
    errorMessageCountryId: '',
    errorMessageLanguageId: '',
  }),

  created() {
    this.$store.dispatch('country/setCountryList');
    this.$store.dispatch('language/setLanguageList');
    this.countryId = this.currentUser.country_id;
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      changeCountryResult: 'user/changeCountryResult',
      countryList: 'country/countryList',
      languageList: 'language/languageList',
    }),
  },

  watch: {
    changeCountryResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/setCurrentUser');
          this.$store.dispatch('user/setCurrentUserDetail');
          this.$emit('handleClose');
        } else {
          const { country_id: countryId, language_id: languageId } = newVal.errors;
          this.errorMessageCountryId = countryId ? countryId[0] : null;
          this.errorMessageLanguageId = languageId ? languageId[0] : null;
        }
      }
    },
  },

  methods: {
    register() {
      const postParams = {
        country_id: this.countryId,
        language_id: this.languageId,
      };
      this.$store.dispatch('user/changeCountry', { postParams });
    },
  },
};

</script>

<style lang="scss" scoped>
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    width: auto;
    padding: 20px;
    width: 600px;
    max-height: 100%;
    overflow-y: auto;
  }
}
.user-register{
  position: relative;
  width: 100%;
  max-width: 800px;
  min-height: 100%;
  padding: 20px 20px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 36px;
  border-top-right-radius: 0;
  color: $baseColor;
  @media screen and  (max-width: $tabletWidth) {
    padding: 30px 20px 20px;
    width: 96%;
  }
  .error{
    background-color: rgba(0, 0, 0 ,0)!important;
    color: $red;
    margin-bottom: 10px;
    text-align: center;
  }
}
.button-area {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .purchase-btn {
    width: 48%;
    border-radius: initial;
  }
}
.address_area {
  margin-top: 20px;
}
@media screen and  (max-width: $tabletWidth) {
  .overlay {
    .modal {
      width: 100%;
    }
  }
}
</style>
